import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';
import { EmptyState } from '@/components/ui/EmptyState';
import { useFeatureFlags, useToggleFeatureFlag } from '@/hooks/useAdminSettings';
import { Flag } from 'lucide-react';

export function FeatureFlagsEditor() {
  const { data, isLoading } = useFeatureFlags();
  const toggle = useToggleFeatureFlag();
  // Service returns FeatureFlag[] directly
  const flags = data || [];

  return (
    <Card>
      <CardHeader title="Feature Flags" description={`${flags.length} flag(s)`} />
      <CardContent>
        {isLoading ? (
          <div className="space-y-2"><Skeleton className="h-10" /><Skeleton className="h-10" /></div>
        ) : flags.length === 0 ? (
          <EmptyState message="Aucun feature flag" icon={<Flag className="h-8 w-8" />} />
        ) : (
          <div className="space-y-2">
            {flags.map((flag) => (
              <div key={flag.key} className="flex items-center justify-between rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-3">
                <div>
                  <p className="text-sm font-medium text-neutral-900 dark:text-neutral-200">{flag.key}</p>
                  <p className="text-xs text-neutral-500">{flag.description}</p>
                </div>
                <button
                  onClick={() => toggle.mutate(flag.key)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${flag.isEnabled ? 'bg-primary-600' : 'bg-neutral-300 dark:bg-neutral-600'}`}
                >
                  <span className={`inline-block h-4 w-4 rounded-full bg-white transition-transform ${flag.isEnabled ? 'translate-x-6' : 'translate-x-1'}`} />
                </button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
